var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithoutText2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Favicon 1",
    clipPath: "url(#clip0_8879_33548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7188 1.25H25.5938L0.984375 23.2812L18.7188 1.25Z",
    fill: "#FEC514"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5469 15.3125L19.1875 23.2812H25.5938L16.2969 11.9531L12.5469 15.3125Z",
    fill: "#152E5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 6.79688L7.46875 1.25H1.0625L8.79688 10.7813L12 6.79688Z",
    fill: "#152E5F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8879_33548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithoutText2);
export default __webpack_public_path__ + "static/media/logoWithoutText2.2312ea07514c7f2ee918785af8f9ad70.svg";
export { ForwardRef as ReactComponent };